// // // // // // // // src/hooks/useAuth.js
// // // // // // // import { createContext, useContext, useEffect, useState } from "react";
// // // // // // // import {
// // // // // // //   onAuthStateChanged,
// // // // // // //   signInWithEmailAndPassword,
// // // // // // //   createUserWithEmailAndPassword,
// // // // // // //   signOut,
// // // // // // //   updateProfile,
// // // // // // // } from "firebase/auth";
// // // // // // // import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
// // // // // // // import { auth, db } from "../utils/firebase";

// // // // // // // const AuthContext = createContext(null);

// // // // // // // export function AuthProvider({ children }) {
// // // // // // //   const [user, setUser] = useState(null);
// // // // // // //   const [userData, setUserData] = useState(null);
// // // // // // //   const [loading, setLoading] = useState(true);

// // // // // // //   useEffect(() => {
// // // // // // //     const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
// // // // // // //       setUser(firebaseUser);
// // // // // // //       if (firebaseUser) {
// // // // // // //         const snap = await getDoc(doc(db, "users", firebaseUser.uid));
// // // // // // //         if (snap.exists()) setUserData(snap.data());
// // // // // // //       } else {
// // // // // // //         setUserData(null);
// // // // // // //       }
// // // // // // //       setLoading(false);
// // // // // // //     });
// // // // // // //     return unsub;
// // // // // // //   }, []);

// // // // // // //   async function signup(firstName, lastName, email, password) {
// // // // // // //     const cred = await createUserWithEmailAndPassword(auth, email, password);
// // // // // // //     await updateProfile(cred.user, { displayName: `${firstName} ${lastName}` });
// // // // // // //     await setDoc(doc(db, "users", cred.user.uid), {
// // // // // // //       firstName,
// // // // // // //       lastName,
// // // // // // //       email,
// // // // // // //       createdAt: serverTimestamp(),
// // // // // // //       totalAnalyses: 0,
// // // // // // //     });
// // // // // // //     setUserData({ firstName, lastName, email, totalAnalyses: 0 });
// // // // // // //     return cred.user;
// // // // // // //   }

// // // // // // //   async function login(email, password) {
// // // // // // //     return signInWithEmailAndPassword(auth, email, password);
// // // // // // //   }

// // // // // // //   async function logout() {
// // // // // // //     await signOut(auth);
// // // // // // //     setUserData(null);
// // // // // // //   }

// // // // // // //   return (
// // // // // // //     <AuthContext.Provider value={{ user, userData, loading, signup, login, logout }}>
// // // // // // //       {children}
// // // // // // //     </AuthContext.Provider>
// // // // // // //   );
// // // // // // // }

// // // // // // // export function useAuth() {
// // // // // // //   return useContext(AuthContext);
// // // // // // // }

// // // // // // src/hooks/useAuth.js
// // // // // import { createContext, useContext, useEffect, useState } from "react";
// // // // // import {
// // // // //   onAuthStateChanged,
// // // // //   signInWithEmailAndPassword,
// // // // //   createUserWithEmailAndPassword,
// // // // //   signOut,
// // // // //   updateProfile,
// // // // // } from "firebase/auth";
// // // // // import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
// // // // // import { auth, db } from "../utils/firebase";
// // // // // import { sendWelcomeEmail } from "../utils/emailService";
// // // // // import { trackAuth, TRACK_EVENTS } from "../utils/trackingService";

// // // // // const AuthContext = createContext(null);

// // // // // export function AuthProvider({ children }) {
// // // // //   const [user, setUser] = useState(null);
// // // // //   const [userData, setUserData] = useState(null);
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   useEffect(() => {
// // // // //     const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
// // // // //       setUser(firebaseUser);
// // // // //       if (firebaseUser) {
// // // // //         const snap = await getDoc(doc(db, "users", firebaseUser.uid));
// // // // //         if (snap.exists()) setUserData(snap.data());
// // // // //       } else {
// // // // //         setUserData(null);
// // // // //       }
// // // // //       setLoading(false);
// // // // //     });
// // // // //     return unsub;
// // // // //   }, []);

// // // // //   async function signup(firstName, lastName, email, password) {
// // // // //     const cred = await createUserWithEmailAndPassword(auth, email, password);
// // // // //     const fullName = `${firstName} ${lastName}`;

// // // // //     await updateProfile(cred.user, { displayName: fullName });

// // // // //     await setDoc(doc(db, "users", cred.user.uid), {
// // // // //       firstName,
// // // // //       lastName,
// // // // //       email,
// // // // //       createdAt: serverTimestamp(),
// // // // //       totalAnalyses: 0,
// // // // //     }, { merge: true });

// // // // //     setUserData({ firstName, lastName, email, totalAnalyses: 0 });

    
// // // // //     // Send welcome + admin notification — non-blocking
// // // // //     sendWelcomeEmail(email, fullName, cred.user.uid).catch(err =>
// // // // //       console.error("Welcome email error:", err)
// // // // //     );

// // // // //     return cred.user;
// // // // //   }

// // // // //   async function login(email, password) {
// // // // //     return signInWithEmailAndPassword(auth, email, password);
// // // // //   }

// // // // //   async function logout() {
// // // // //     await signOut(auth);
// // // // //     setUserData(null);
// // // // //   }

// // // // //   return (
// // // // //     <AuthContext.Provider value={{ user, userData, loading, signup, login, logout }}>
// // // // //       {children}
// // // // //     </AuthContext.Provider>
// // // // //   );
// // // // // }

// // // // // export function useAuth() {
// // // // //   return useContext(AuthContext);
// // // // // }

// // // // src/hooks/useAuth.js
// // // import { createContext, useContext, useEffect, useState } from "react";
// // // import {
// // //   onAuthStateChanged,
// // //   signInWithEmailAndPassword,
// // //   createUserWithEmailAndPassword,
// // //   signOut,
// // //   updateProfile,
// // // } from "firebase/auth";
// // // import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
// // // import { auth, db } from "../utils/firebase";
// // // import { sendWelcomeEmail } from "../utils/emailService";

// // // const AuthContext = createContext(null);

// // // export function AuthProvider({ children }) {
// // //   const [user, setUser] = useState(null);
// // //   const [userData, setUserData] = useState(null);
// // //   const [loading, setLoading] = useState(true);

// // //   useEffect(() => {
// // //     const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
// // //       setUser(firebaseUser);
// // //       if (firebaseUser) {
// // //         const snap = await getDoc(doc(db, "users", firebaseUser.uid));
// // //         if (snap.exists()) setUserData(snap.data());
// // //       } else {
// // //         setUserData(null);
// // //       }
// // //       setLoading(false);
// // //     });
// // //     return unsub;
// // //   }, []);

// // //   async function signup(firstName, lastName, email, password) {
// // //     const cred = await createUserWithEmailAndPassword(auth, email, password);
// // //     const fullName = `${firstName} ${lastName}`;
// // //     await updateProfile(cred.user, { displayName: fullName });
// // //     await setDoc(doc(db, "users", cred.user.uid), {
// // //       firstName,
// // //       lastName,
// // //       email,
// // //       createdAt: serverTimestamp(),
// // //       totalAnalyses: 0,
// // //     }, { merge: true });
// // //     setUserData({ firstName, lastName, email, totalAnalyses: 0 });
// // //     sendWelcomeEmail(email, fullName, cred.user.uid).catch(err =>
// // //       console.error("Welcome email error:", err)
// // //     );
// // //     return cred.user;
// // //   }

// // //   async function login(email, password) {
// // //     return signInWithEmailAndPassword(auth, email, password);
// // //   }

// // //   async function logout() {
// // //     await signOut(auth);
// // //     setUserData(null);
// // //   }

// // //   return (
// // //     <AuthContext.Provider value={{ user, userData, loading, signup, login, logout }}>
// // //       {children}
// // //     </AuthContext.Provider>
// // //   );
// // // }

// // // export function useAuth() {
// // //   return useContext(AuthContext);
// // // }

// // src/hooks/useAuth.js
// import { createContext, useContext, useEffect, useState } from "react";
// import {
//   onAuthStateChanged,
//   signInWithEmailAndPassword,
//   createUserWithEmailAndPassword,
//   signOut,
//   updateProfile,
//   sendEmailVerification,
// } from "firebase/auth";
// import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
// import { auth, db } from "../utils/firebase";
// import { sendWelcomeEmail } from "../utils/emailService";

// const AuthContext = createContext(null);

// export function AuthProvider({ children }) {
//   const [user, setUser] = useState(null);
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
//       setUser(firebaseUser);
//       if (firebaseUser) {
//         const snap = await getDoc(doc(db, "users", firebaseUser.uid));
//         if (snap.exists()) setUserData(snap.data());
//       } else {
//         setUserData(null);
//       }
//       setLoading(false);
//     });
//     return unsub;
//   }, []);

//   async function signup(firstName, lastName, email, password) {
//     const cred = await createUserWithEmailAndPassword(auth, email, password);
//     const fullName = `${firstName} ${lastName}`;

//     await updateProfile(cred.user, { displayName: fullName });

//     // Send Firebase email verification
//     await sendEmailVerification(cred.user);

//     await setDoc(doc(db, "users", cred.user.uid), {
//       firstName,
//       lastName,
//       email,
//       createdAt: serverTimestamp(),
//       totalAnalyses: 0,
//       emailVerified: false,
//     }, { merge: true });

//     setUserData({ firstName, lastName, email, totalAnalyses: 0, emailVerified: false });

//     sendWelcomeEmail(email, fullName, cred.user.uid).catch(err =>
//       console.error("Welcome email error:", err)
//     );

//     return cred.user;
//   }

//   async function login(email, password) {
//     return signInWithEmailAndPassword(auth, email, password);
//   }

//   async function logout() {
//     await signOut(auth);
//     setUserData(null);
//   }

//   // Resend verification email
//   async function resendVerificationEmail() {
//     if (auth.currentUser) {
//       await sendEmailVerification(auth.currentUser);
//     }
//   }

//   return (
//     <AuthContext.Provider value={{ user, userData, loading, signup, login, logout, resendVerificationEmail }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export function useAuth() {
//   return useContext(AuthContext);
// }

// src/hooks/useAuth.js
import { createContext, useContext, useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  updateProfile,
  sendEmailVerification,
  sendPasswordResetEmail,
} from "firebase/auth";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../utils/firebase";
import { sendWelcomeEmail } from "../utils/emailService";

const AuthContext = createContext(null);

// ── Complete user profile shape ──
// Always use this so AdminPage always has all fields
function buildUserProfile(overrides = {}) {
  return {
    firstName:             "",
    lastName:              "",
    email:                 "",
    displayName:           "",
    emailVerified:         false,
    totalPayments:         0,
    totalAnalyses:         0,
    totalResumesGenerated: 0,
    totalDownloads:        0,
    ...overrides,
  };
}

export function AuthProvider({ children }) {
  const [user, setUser]         = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        try {
          const snap = await getDoc(doc(db, "users", firebaseUser.uid));

          if (snap.exists()) {
            const data = snap.data();

            // ── Backfill missing fields for existing users ──
            // (users created before this fix won't have all fields)
            const needsBackfill =
              data.totalPayments         === undefined ||
              data.totalResumesGenerated === undefined ||
              data.displayName           === undefined;

            if (needsBackfill) {
              const nameParts = (firebaseUser.displayName || "").split(" ");
              const patch = {
                firstName:             data.firstName             ?? nameParts[0] ?? "",
                lastName:              data.lastName              ?? nameParts.slice(1).join(" ") ?? "",
                email:                 data.email                 ?? firebaseUser.email ?? "",
                displayName:           data.displayName           ?? firebaseUser.displayName ?? "",
                emailVerified:         data.emailVerified         ?? firebaseUser.emailVerified ?? false,
                totalPayments:         data.totalPayments         ?? 0,
                totalAnalyses:         data.totalAnalyses         ?? 0,
                totalResumesGenerated: data.totalResumesGenerated ?? 0,
                totalDownloads:        data.totalDownloads        ?? 0,
              };
              await setDoc(doc(db, "users", firebaseUser.uid), patch, { merge: true });
              setUserData({ ...data, ...patch });
            } else {
              setUserData(data);
            }

          } else {
            // ── No doc yet (Google OAuth, missing doc, etc.) ──
            const nameParts = (firebaseUser.displayName || "").split(" ");
            const profile = {
              ...buildUserProfile({
                firstName:    nameParts[0] || "",
                lastName:     nameParts.slice(1).join(" ") || "",
                email:        firebaseUser.email || "",
                displayName:  firebaseUser.displayName || "",
                emailVerified: firebaseUser.emailVerified,
              }),
              createdAt: serverTimestamp(),
            };
            await setDoc(doc(db, "users", firebaseUser.uid), profile);
            setUserData(profile);
          }
        } catch (err) {
          console.error("Failed to load/create user profile:", err);
        }
      } else {
        setUserData(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  // ─────────────────────────────────────────────
  // SIGNUP — saves complete profile to Firestore
  // ─────────────────────────────────────────────
  async function signup(firstName, lastName, email, password) {
    const cred     = await createUserWithEmailAndPassword(auth, email, password);
    const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();

    // 1. Update Firebase Auth displayName
    await updateProfile(cred.user, { displayName: fullName });

    // 2. Send verification email
    await sendEmailVerification(cred.user);

    // 3. Write COMPLETE profile to Firestore
    //    This is what AdminPage reads — must have all fields
    const profile = {
      ...buildUserProfile({
        firstName:    firstName.trim(),
        lastName:     lastName.trim(),
        email:        email.toLowerCase().trim(),
        displayName:  fullName,
        emailVerified: false,
      }),
      createdAt: serverTimestamp(),
    };

    await setDoc(doc(db, "users", cred.user.uid), profile);

    // 4. Update local state immediately
    setUserData(profile);

    // 5. Send welcome email (fire and forget)
    console.log("Sending welcome email...");
    sendWelcomeEmail(email, fullName, cred.user.uid).catch(err =>
      console.error("Welcome email error:", err)
    );

    return cred.user;
  }

  // ─────────────────────────────────────────────
  // LOGIN
  // ─────────────────────────────────────────────
  async function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  // ─────────────────────────────────────────────
  // LOGOUT
  // ─────────────────────────────────────────────
  async function logout() {
    await signOut(auth);
    setUserData(null);
  }

  // ─────────────────────────────────────────────
  // RESEND VERIFICATION
  // ─────────────────────────────────────────────
  async function resendVerificationEmail() {
    if (auth.currentUser) {
      await sendEmailVerification(auth.currentUser);
    }
  }

  // ─────────────────────────────────────────────
  // RESET PASSWORD
  // ─────────────────────────────────────────────
  async function resetPassword(email) {
    await sendPasswordResetEmail(auth, email);
  }

  // ─────────────────────────────────────────────
  // UPDATE PROFILE
  // ─────────────────────────────────────────────
  async function updateUserProfile(updates) {
    if (!user) return;
    await setDoc(
      doc(db, "users", user.uid),
      { ...updates, updatedAt: serverTimestamp() },
      { merge: true }
    );
    setUserData(prev => ({ ...prev, ...updates }));
    if (updates.firstName || updates.lastName) {
      const newName = `${updates.firstName || userData?.firstName || ""} ${updates.lastName || userData?.lastName || ""}`.trim();
      await updateProfile(user, { displayName: newName });
    }
  }

  return (
    <AuthContext.Provider value={{
      user,
      userData,
      loading,
      signup,
      login,
      logout,
      resetPassword,
      resendVerificationEmail,
      updateUserProfile,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
